/* eslint-disable no-console */
import { Injectable, signal, effect } from '@angular/core';

import { decodeJWT } from '@senet-uiverse/common';

import { IStorageData, ITokenData } from '../types';

const STORAGE_KEY = '[SENET_ID] storage';

const STORAGE_DEFAULT_DATA = { user: null, organization: null, organizationProfile: null, organizationInfo: null };

@Injectable({ providedIn: 'root' })
export class StorageService {
  readonly storage = signal<IStorageData>(STORAGE_DEFAULT_DATA);
  sessionStorageMode = false;

  constructor() {
    this.getFromStorageData();

    effect(() => {
      this.storage();
      this.updateStorage();
    });
  }

  update(data: Partial<IStorageData>) {
    this.storage.update((prev) => ({ ...prev, ...data }));
  }

  clear() {
    this.storage.set(STORAGE_DEFAULT_DATA);
    this.updateStorage();
  }

  getTokenData() {
    const token = this.storage().user?.keycloak_access_token;

    if (!token) return null;

    const data = decodeJWT<ITokenData>(token);

    return data;
  }

  private getFromStorageData() {
    try {
      const storageData = localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY);

      this.storage.set(storageData ? JSON.parse(storageData) : STORAGE_DEFAULT_DATA);
    } catch (e) {
      console.error('Помилка при отриманні даних з localStorage', e);
    }
  }

  private updateStorage() {
    if (this.sessionStorageMode) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.storage()));
    } else {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.storage()));
    }
  }
}
